import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { venueDetailQueryOptions, venuesQueryOptions } from '@/features/venues/api'
import { VenuesPage } from '@/features/venues/pages/venues-page'
import { workspaceQueryOptions } from '@/lib/workspace'

export const Route = createFileRoute('/_auth/w/$workspaceSlug/venues/$venueId')({
  loader: async ({ context, params }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(venuesQueryOptions(params.workspaceSlug)),
      context.queryClient.ensureQueryData(
        venueDetailQueryOptions(params.workspaceSlug, params.venueId),
      ),
    ])
  },
  component: VenueRoute,
})

function VenueRoute() {
  const { workspaceSlug, venueId } = Route.useParams()
  const workspace = useQuery(workspaceQueryOptions(workspaceSlug))
  return (
    <VenuesPage
      workspaceSlug={workspaceSlug}
      venueId={venueId}
      canWrite={workspace.data?.role !== 'viewer'}
    />
  )
}
